import { useState } from "react"

export default function List({contacts}) {

    const [isActive, setActive] = useState(true)

    const handleToggle = () => {
        setActive(!isActive)

    }


//     const [showMore, setShowMore] = useState(false);


//   const [isReadMore, setIsReadMore] = useState(true);
//   const toggleReadMore = () => {
//     setIsReadMore(!isReadMore);
//   };



// const [readMore, setReadMore] = useState(false);

// const extraContent=<div>
//       <p className="extra-content">
//         Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui, consectetur nequeab 
//         porro quasi culpa nulla rerum quis minus voluptatibus sed hic ad quo sint, libero 
//         commodi officia aliquam! Maxime.
//       </p>
//   </div>
// const linkName=readMore?'Read Less << ':'Read More >> '

//                     <a className="read-more-link" onClick={()=>{setReadMore(!readMore)}}><h2>{linkName}</h2></a>
//       {readMore && extraContent}







// const ReadMore = ({ children }) => {
//   const text = children;
//   const [isReadMore, setIsReadMore] = useState(true);
//   const toggleReadMore = () => {
//     setIsReadMore(!isReadMore);
//   };
//   return (
//     <p className="text">
//       {isReadMore ? text.slice(0, 10) : text}
//       <span onClick={toggleReadMore} className="read-or-hide">
//         {isReadMore ? "...read more" : " show less"}
//       </span>
//     </p>
//   );
// };






    // const [isOpen, setIsOpen] = useState(true);



    function strip(string) {
        if (string != null) {
         return string.replace(/(<([^>]+)>)/gi, "");
        }
        if (string === undefined || string === null) {
            return string = ''
            // wtf
        }
    }

    // function stripHtml(html) {
    //     let tmp = document.createElement("DIV");
    //     tmp.innerHTML = html;
    //     return tmp.textContent || tmp.innerText || "";
    // }

    // function checkIfImageExists(url, callback) {
    //     const img = new Image();
    //     img.src = url;

    //     if (img.complete) {
    //         callback(true);
    //     } else {
    //         img.onload = () => {
    //             callback(true);
    //         };

    //         img.onerror = () => {
    //             callback(false);
    //         };
    //     }
    // }

    const fallbackSrc = process.env.PUBLIC_URL;
    console.log(fallbackSrc)

    return (
        <div className="grid">

            {contacts.map((contact, index) => {


                // console.log(contact.weight)

                let weightkg = contact.weight
                if (weightkg != null) {
                weightkg = weightkg.replace(/pounds/g, 'kilo')
                weightkg = weightkg.replace(/\d+\d+/, (match) => {
                return ( +match / 2.2).toFixed(2); 
                                });          
                }
                // console.log(weightkg)
                let details = contact.details
                let caution  = contact.caution 

                // console.log(caution)
                details = strip(details)
                caution  = strip(caution)
                // console.log(contact.images)
                // console.log(JSON.stringify(contact.aliases))
                // console.log(contact.aliases)


                function inchToCm(num) {
                    return (num * 2.54).toFixed(2);
                }




                // let img = new Image();
                // img.src = leimage
                // img.onerror = () => {
                //     img.src = fallbackSrc
                // }
                    // contact.aliases.map((alias, i) => {
                    //     return (
                    //         console.log(alias)
                    //     )
                    // })
                return (
                    <div className="card" key={index}>
                        <div className="header" key={contacts.uid}>
                            <svg viewBox="0 0 474.3 311.6">
                                <path d="M0 0h125.1v22.4H24.3v36.9h97v22.4h-97v62.9H0V0zM150.8 0h24.3v144.6h-24.3V0zm12.8 122.2h199.3c8.7 0 15.2-1.4 19.4-4.2 4.3-2.8 6.4-7.8 6.4-15.2s-2.1-12.5-6.3-15.3c-4.2-2.8-10.7-4.2-19.6-4.2H163.6v-22h193.9c5.9 0 10.7-.6 14.4-1.7 3.7-1.1 6.5-3.1 8.4-6 1.9-2.9 2.9-6.8 2.9-11.9 0-7.2-2.1-12.2-6.3-15-4.2-2.8-10.7-4.2-19.4-4.2H163.6V0h188.7c18 0 31.7 3 41.1 8.9 9.4 5.9 14.1 15.8 14.1 29.6 0 9.1-2.1 16.7-6.4 22.9-4.3 6.2-11.1 10.9-20.6 14.1l-1.5-8.2c12 2.6 20.6 7.2 26 13.8 5.4 6.5 8 14.8 8 24.9 0 13.9-4.7 23.8-14.1 29.7-9.4 5.9-23.2 8.9-41.3 8.9h-194v-22.4zM434.7 0H459v144.6h-24.3V0zM221.1 167v144.6h-24.3V177.8l6.6 3-77.9 92H95.4l-77.9-89.4 6.7-3.2v131.3H0V167h34.3l82.7 95.2-13.1.1 81.7-95.3h35.5zM239.2 167h26.5l42.2 133.3h-8.4l42-133.3H372l42.1 133.4h-8.4l42-133.4h26.6l-49.2 144.6h-31.4l-41.1-133.4h8.2l-41.3 133.4h-31.4L239.2 167z" />
                            </svg>
                            {/* <a href={contact.url} className='title' id='black'> </a> */}

                            <h1 className="title" id="black">
                                {" "}
                            </h1>
                            <h4
                                className="headline"
                                data-text={contact.title}
                                title={contact.title}
                            >
                                {contact.title}
                            </h4>
                        </div>
                        <img
                            src={contact.images[0].large}
                            alt={contact.images[0].caption}
                            loading="lazy"
                            onError={(e) => {
                                e.target.onError = null;
                                e.target.src = "logo.svg";
                            }}
                        />

                        {/* <h4 className='headline' data-text={contact.title} title={contact.title}>{contact.title}</h4> */}
                        {/* <img src={contact.images[0].large} 
                        alt={contact.images[0].caption} 
                        loading='lazy' 
                        onError={(e)=>{e.target.onError = null; e.target.src = 'logo.svg'}}/> */}

                        {/* <h3 className='fit' data-text={contact.title} title={contact.title}>{contact.title}</h3> */}
                        <p className="desc">
                            <strong>{contact.description}</strong>
                        </p>

                        {details ? (
                            <>
                                <div className="toggler">
                                    <small
                                        className={
                                            !isActive ? "read-more-x" : "x"
                                        }
                                    >
                                        {!isActive
                                            ? details
                                            : `${details.substring(0, 230)}`}
                                    </small>
                                    <button
                                        onClick={handleToggle}
                                        className="button more-text"
                                    >
                                        {!isActive
                                            ? "Show less"
                                            : "Details, Show more "}
                                    </button>
                                </div>
                            </>
                        ) : (
                            ""
                        )}
                        {caution ? (
                            <>
                                <div className="toggler">
                                    <small
                                        className={
                                            !isActive ? "read-more-x" : "x"
                                        }
                                    >
                                        {!isActive
                                            ? caution
                                            : `${caution.substring(0, 230)}`}
                                    </small>
                                    <button
                                        onClick={handleToggle}
                                        className="button more-text"
                                    >
                                        {!isActive
                                            ? "Show less"
                                            : "Caution, show more"}
                                    </button>
                                </div>
                            </>
                        ) : (
                            ""
                        )}

                        {/* <p className="details">
                                {!isReadMore ?  details : `${details.substring(0, 130)}`}
                                <span onClick={toggleReadMore} className="read-or-hide">
                                    {!isReadMore ? "...read more" : " show less"}
                                </span>
                                </p> */}
                        {contact.reward_text ? (
                            <p className="reward">
                                {contact.reward_text.replace(
                                    /(.+\$\d.+\d|.+\$\d.+million)|[\s\S]/gi,
                                    "$1"
                                )}
                            </p>
                        ) : (
                            ""
                        )}
                        {contact.warning_message ? (
                            <p className="warning">{contact.warning_message}</p>
                        ) : (
                            ""
                        )}

                        {/* <small className={isActive ? 'read-more' : 'x'}>{caution }</small> */}
                        {/* <small className={isActive ? 'read-more' : 'x'}>{details}</small> */}
                        {/* <button onClick={handleToggle} className='button more-text'> Read more </button> */}

                        {/* <button className='button more-text' onClick={() => setIsOpen(!isOpen)}>{isOpen ? "Show less" : "Show more"}</button>
                        {isOpen && (
                    <>
                    <small>{`${details.substring(0, 130)}` ? details : 'sadfasf'}</small>
                    </>
                    )} */}

                        {/* {showMore ? {details} : <small className='read-more'>{details}</small>} */}

                        {/* <button className="btn" onClick={() => setShowMore(!showMore)}>
                        {showMore ? "Show less" : "Show more"}
                        </button> */}
                        <ul className="info">
                            {contact.dates_of_birth_used ? (
                                <li>
                                    <span>DOB: </span>
                                    {contact.dates_of_birth_used.map((d, i) => {
                                        return (
                                            <p key={i} className="alias">
                                                {d}
                                            </p>
                                        );
                                    })}
                                </li>
                            ) : (
                                ""
                            )}

                            {contact.eyes ? (
                                <li>
                                    <span>Eyes: </span>
                                    {contact.eyes}
                                </li>
                            ) : (
                                ""
                            )}

                            {contact.race ? (
                                <li>
                                    <span>Race (wtf?!): </span>
                                    {contact.race}
                                </li>
                            ) : (
                                ""
                            )}
                            {contact.race_raw ? (
                                <li>
                                    <span>Race: (wtf?!)</span>
                                    {contact.race_raw}
                                </li>
                            ) : (
                                ""
                            )}

                            {contact.weight ? (
                                <li>
                                    <span>Weight: </span>
                                    {contact.weight}
                                </li>
                            ) : (
                                ""
                            )}
                            {weightkg ? (
                                <li>
                                    <span>Weight: </span>
                                    {weightkg}
                                </li>
                            ) : (
                                ""
                            )}
                            {contact.nationality ? (
                                <li>
                                    <span>Nationality: </span>
                                    {contact.nationality}
                                </li>
                            ) : (
                                ""
                            )}
                            {contact.height_max ? (
                                <li>
                                    <span>Length: </span>
                                    {inchToCm(contact.height_max)} cm
                                </li>
                            ) : (
                                ""
                            )}

                            {contact.place_of_birth ? (
                                <li>
                                    <span>Birth place: </span>
                                    {contact.place_of_birth}
                                </li>
                            ) : (
                                ""
                            )}
                            {contact.scars_and_marks ? (
                                <li>
                                    <span>Scars/Info: </span>
                                    {contact.scars_and_marks}
                                </li>
                            ) : (
                                ""
                            )}
                            {contact.age_range ? (
                                <li>
                                    <span>Age approx: </span>
                                    {contact.age_range}
                                </li>
                            ) : (
                                ""
                            )}
                            {contact.age_max ? (
                                <li>
                                    <span>Age: </span>
                                    {contact.age_max}
                                </li>
                            ) : (
                                ""
                            )}
                            {contact.remarks ? (
                                <li>
                                    <span>info: </span>
                                    {strip(contact.remarks)}
                                </li>
                            ) : (
                                ""
                            )}

                            {contact.aliases ? (
                                <li>
                                    <span>Aliases: </span>
                                    {contact.aliases.map((a, i) => {
                                        return (
                                            <p key={i} className="alias">
                                                {a}
                                            </p>
                                        );
                                    })}
                                </li>
                            ) : (
                                ""
                            )}
                        </ul>

                        {/* <a href={contact.url}>{contact.uid}</a>        */}
                    </div>
                ); 
                
            })}
        </div>
    )
}
